import React from 'react';
import styles from './comments.module.scss';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';

const Timestamp = ({ time, onClick }) => {
  const myRef = useAccessibleClick(onClick);

  return (
    <span
      ref={myRef}
      tabIndex={0}
      onClick={onClick}
      className={styles.commentTimeline}
    >
      {time}
    </span>
  )
};

export default Timestamp;

